export default __webpack_public_path__ + "static/media/ico_calender_gray.271e9906.svg";